/* eslint-disable max-len */
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import PigMistake from '../animations/pig-mistake';
import PigOink from '../animations/pig-oink';
import QuestionMark from '../animations/question-mark';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CountingCurrency.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CountingCurrency.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.answers = [];
  this.cashPoint = new Phaser.Geom.Point(1150, 370);
  this.coinsPoint = new Phaser.Geom.Point(1200, 640);
  this.cashGroup = null;
  this.coinsGroup = null;
  this.pigErrorAnim = null;
  this.pigOinkAnim = null;
  this.cashLoaded = false;
  this.coinsLoaded = false;
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountingCurrency.Scenes.Main.prototype.constructor = EDC.Games.CountingCurrency.Scenes.Main;
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.add.sprite(this.game.config.width / 2, 1030, 'title');

  // eslint-disable-next-line prefer-const
  let pig = this.add.sprite(310, 230, 'pig');
  this.pigErrorAnim = new PigMistake(this, pig);
  this.pigOinkAnim = new PigOink(this);
  this.pigOinkAnim.create();

  const questionMarks = new QuestionMark(this);
  questionMarks.create().start();

  this.createAnswers();

  this.cashGroup = this.add.container(0, 0);
  this.coinsGroup = this.add.container(0, 0);

  this.loadTask();

  this.createBasicUI();
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.createAnswers = function () {
  const places = [
    new Phaser.Geom.Point(340, 797),
    new Phaser.Geom.Point(745, 860),
    new Phaser.Geom.Point(1150, 820),
    new Phaser.Geom.Point(1565, 855),
  ];
  for (let i = 0; i < 4; i++) {
    const answerContainer = this.add.container(places[i].x, places[i].y);
    const answer = this.add.sprite(0, 0, 'sticker');
    answerContainer.add(answer);

    const label = this.add
      .text(0, 0, '', {
        fontFamily: 'Arial',
        fontSize: '80px',
        fontStyle: 'bold',
        fill: 'black',
      })
      .setOrigin(0.5);
    answerContainer.add(label);
    label.setAlpha(0);

    const markAnim = new AnswerMark(this, answerContainer).setScale(0.45);
    answerContainer.setData('markAnim', markAnim);

    const bounds = answerContainer.getBounds();
    answerContainer.setData('index', i);
    answerContainer.setSize(bounds.width, bounds.height);
    answerContainer.setInteractive();
    answerContainer.on('pointerup', this.onAnswerUp.bind(this, answerContainer), this);

    this.cursorManager.setDefaultDraggableEvents(answerContainer);

    this.answers.push(answerContainer);
  }
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.onAnswerUp = function (target) {
  const set = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (target.getAt(1).text !== this.gameConfig.symbols[set.type] + set.correctAnswer) {
    target.getData('markAnim').showMark(false, () => {});
    target.getAt(0).setTint(0xff0000);
    target.removeInteractive();
    this.playWrong();
    this.pigErrorAnim.play();
  } else {
    this.playCorrect();
    target.removeInteractive();
    target.getData('markAnim').showMark(true, this.disappearAnswers.bind(this));
  }
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.checkTaskLoaded = function () {
  if (this.cashLoaded && this.coinsLoaded) {
    this.appearAnswers();
  }
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.appearCash = function () {
  const cash = this.cashGroup.getAll();
  const duration = 300;
  if (cash.length === 0) {
    this.cashLoaded = true;
  }
  for (let i = 0; i < cash.length; i++) {
    this.tweens.add({
      targets: cash[i],
      alpha: 1,
      duration,
      ease: 'Linear',
      delay: duration * i,
      onComplete: function (index, length) {
        if (index >= length - 1) {
          this.cashLoaded = true;
          this.checkTaskLoaded();
        }
      }.bind(this, i, cash.length),
    });
  }
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.appearCoins = function () {
  const coins = this.coinsGroup.getAll();
  const duration = 300;
  for (let i = 0; i < coins.length; i++) {
    this.tweens.add({
      targets: coins[i],
      alpha: 1,
      duration,
      ease: 'Linear',
      delay: duration * i,
      onComplete: function (index, length) {
        if (index >= length - 1) {
          this.coinsLoaded = true;
          this.checkTaskLoaded();
        }
      }.bind(this, i, coins.length),
    });
  }
};
/**
 *
 */
EDC.Games.CountingCurrency.Scenes.Main.prototype.nextIteration = function () {
  this.cashLoaded = false;
  this.coinsLoaded = false;
  this.cashGroup.removeAll(true);
  this.coinsGroup.removeAll(true);
  for (let i = 0; i < this.answers.length; i++) {
    this.answers[i].getAt(0).setTint(0xffffff);
    this.answers[i].getData('markAnim').reset();
  }
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.answers.forEach((elem) => {
      elem.removeInteractive();
    });
    this.cursorManager.resetCursor();
    this.showSummary();
  } else {
    this.loadTask();
  }
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.disappearAnswers = function () {
  for (let i = 0; i < this.answers.length; i++) {
    const text = this.answers[i].getAt(1);
    this.tweens.add({
      targets: text,
      alpha: 0,
      duration: 500,
      ease: 'Linear',
      onComplete: function (index) {
        if (index >= this.answers.length - 1) {
          this.nextIteration();
        }
      }.bind(this, i),
    });
  }
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.appearAnswers = function () {
  for (let i = 0; i < this.answers.length; i++) {
    const text = this.answers[i].getAt(1);
    this.tweens.add({
      targets: text,
      alpha: 1,
      duration: 500,
      ease: 'Linear',
      onComplete: function (index) {
        this.answers[index].setInteractive();
      }.bind(this, i),
    });
  }
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.loadTask = function () {
  const set = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const currency = this.gameConfig.symbols[set.type];
  for (let i = 0; i < this.answers.length; i++) {
    const label = this.answers[i].getAt(1);
    label.setText(currency + set.answers[i]);
  }
  this.loadCash(set);
  this.loadCoins(set);
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.loadCash = function (set) {
  const defaultRowStep = 45;
  const defaultColStep = 150;
  const cashInColumn = 3;
  const cash = [];
  for (let i = 0; i < set.values.length; i++) {
    if (set.values[i] >= 1) {
      cash.push(set.values[i]);
    }
  }

  if (set.inOrder) {
    cash.sort((a, b) => a - b);
  }

  // const columns = Math.ceil(cash.length / cashInColumn);
  let currentColumn = 0;
  let currentIndexInColumn = 0;
  let currentHeight = 0;

  for (let i = 0; i < cash.length; i++) {
    if (currentIndexInColumn >= cashInColumn) {
      currentIndexInColumn = 0;
      currentColumn += 1;
      currentHeight = 0;
    }
    const x = defaultColStep * currentColumn;
    const y = currentHeight;

    const value = cash[i];
    const sprite = this.add.sprite(x, y, `${set.type}-${value}`).setOrigin(0);
    this.cashGroup.add(sprite);
    sprite.setAlpha(0);

    currentHeight += value === '1' ? defaultRowStep + 50 : defaultRowStep;
    currentIndexInColumn += 1;
  }
  this.cashGroup.x = this.cashPoint.x - this.cashGroup.getBounds().width / 2;
  this.cashGroup.y = this.cashPoint.y - this.cashGroup.getBounds().height / 2;
  this.appearCash();
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.loadCoins = function (set) {
  const coins = [];
  for (let i = 0; i < set.values.length; i++) {
    if (set.values[i] < 1) {
      coins.push(set.values[i]);
    }
  }

  if (set.inOrder) {
    coins.sort((a, b) => a - b);
  }

  const step = 20;
  let width = 0;
  for (let i = 0; i < coins.length; i++) {
    const value = coins[i];
    const sprite = this.add.sprite(0, 0, `${set.type}-${value}-${this.getRandomSide()}`);
    sprite.setPosition(width, 0);
    sprite.setAlpha(0);
    width += sprite.width + step;
    this.coinsGroup.add(sprite);
  }

  this.coinsGroup.x = this.coinsPoint.x - this.coinsGroup.getBounds().width / 2;
  this.coinsGroup.y = this.coinsPoint.y;
  this.appearCoins();
};

EDC.Games.CountingCurrency.Scenes.Main.prototype.getRandomSide = function () {
  const sides = ['A', 'B'];
  const rndSideIndex = Math.floor(Math.random() * sides.length);
  return sides[rndSideIndex];
};

export default EDC.Games.CountingCurrency.Scenes.Main;
